export default __webpack_public_path__ + "static/media/get_pitted.66d386cf.png";